export const REQUEST_CHARTS = 'zola/seatingChart/request_charts';
export const RECEIVE_CHARTS = 'zola/seatingChart/receive_charts';
export const REQUEST_CHART = 'zola/seatingChart/request_chart';
export const RECEIVE_CHART = 'zola/seatingChart/receive_chart';
export const CREATE_CHART = 'zola/seatingChart/create_chart';
export const UPDATE_CHART = 'zola/seatingChart/update_chart';
export const DELETE_CHART = 'zola/seatingChart/update_chart';
export const CHANGE_VIEW = 'zola/seatingChart/change_view';
export const SHOW_DETAILS = 'zola/seatingChart/show_details';
export const REQUEST_TABLE = 'zola/seatingChart/request_table';
export const RECEIVE_TABLE = 'zola/seatingChart/receive_table';
export const REQUEST_TABLES = 'zola/seatingChart/request_tables';
export const RECEIVE_TABLES = 'zola/seatingChart/receive_tables';
export const CREATE_TABLE = 'zola/seatingChart/create_table';
export const DELETE_TABLE = 'zola/seatingChart/delete_table';
export const UPDATE_TABLE = 'zola/seatingChart/update_table';



/** WEBPACK FOOTER **
 ** ./src/actions/types/SeatingChartActionTypes.js
 **/